import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ArtFormFields } from "web_myplann/Portfolio/Forms/ArtForm/ArtFormFields";
import { useCreateArtForm } from "web_myplann/Portfolio/Forms/ArtForm/useCreateArtForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateArtForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateArtForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<ArtFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
